module.exports = __webpack_public_path__ + "img/sv21.821f5e51.svg";